export default "__VITE_ASSET__DvclyYyo__"